import axios from '@api'
import constants from '@/services/constants'

export default {
  searchUserInRole (roleId, keyword) {
    return axios.get(`api/user/role/${roleId}?keyword=${keyword}`)
  },
  getUserApprover () {
    return axios.get(`api/user?role=${constants.USER_ROLE.APPROVER}`)
  },
  getUserByUpnInAd (upn) {
    return axios.get(`api/user/activedirectory?upn=${encodeURIComponent(upn)}`)
  },
  searchUserInAD (keyword) {
    return axios.get(`api/user/searchactivedirectory?keyword=${encodeURIComponent(keyword)}`)
  },
  getUserListByUpnInAd (json) {
    return axios.post('api/user/getuserlist', json)
  },
  getUserInventorySpecialist () {
    return axios.get('api/user/getuserinventoryspecialist')
  },
  getUserRole () {
    return axios.get('api/user/role')
  },
  saveUserRole (form) {
    return axios.post('api/user/role', form)
  },
  getGraphUser (keyword) {
    return axios.get(`api/user/graph?keyword=${encodeURIComponent(keyword)}`)
  },
  getGraphGroup (keyword) {
    return axios.get(`api/user/graph/group?keyword=${encodeURIComponent(keyword)}`)
  },
  getEmailGroupList () {
    return axios.get('api/user/emailgrouplist')
  },
  saveEmailGroupList (json) {
    return axios.post('api/user/saveemailgrouplist', json)
  }
}
